// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f96ed26e","513":"71e6fea0","703":"38161f7e","787":"2d2d6331"}[chunkId] + ".chunk.js";
};